export enum CurrentPalletLocationEnum {
    WAREHOUSE = 'WAREHOUSE',
    INSPECTION = 'INSPECTION',
    CUTTING = 'CUTTING',
    NONE = 'NONE'
}
